import styled from "styled-components";

export const TopHeading = styled.div`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 15px;
    align-items: center;
    padding: 16px 0;
    /* > div {
        display: grid;
        gap: 5px;
    } */
    h4 {
        font-size: 20px;
        line-height: 24px;
        letter-spacing: 0.005em;
        color: #005586;
        font-family: "latobold";
        margin: 5px 0;
    }
    p {
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.005em;
        color: rgba(17, 17, 17, 0.8);
        margin: 5px 0;

    }
`
export const OuterWrapper = styled.div`
    padding: 0 90px 30px;
    min-height: calc(100vh - 98px);
    max-width: 1920px;
    margin: 0 auto;

    /* .form-wrapper {
        max-width: 1752px;
            margin: 0 auto; 
    } */
    
`
export const BodyContainer = styled.div``;
export const Footer = styled.div`
  margin-top: 20px;
  /* margin-bottom: 24px; */
  button {
    width: 100%;
    max-width: 272px;
    margin: 0 auto;
    height: 36px;
    border-radius: 5px;
    background: linear-gradient(180deg, #61b01f 0, #27911b) !important;
    font-size: 16px !important;
  }
  button:hover {
    // opacity: 0.4;
  }
`;
export const FormWrapper = styled.div`
    padding: 30px 54px;
    background: #FFFFFF;
    border: 1.5px solid rgba(211, 211, 211, 0.5);
    border-radius: 15px;
    max-height: calc(100vh - 239px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 30px;
    .request-order-upload-section {
        .error-message-multiple {
            position: absolute;
            top: 11px;
            left: 227px;
        }
   }
   .material-and-Condition {
    display: flex;
    /* gap: 80px; */
   }
   .loan-detail-wrapper {
    display: grid;
    align-items: flex-end;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 104px;
    gap: 40px;
    > button {
        height: 36px;
        width: 106px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        background: #FFFFFF;
        border: 1px solid #303030;
        border-radius: 40px;
        margin-bottom: 8px;
        gap: 5px;
        &.add-more {
            background: linear-gradient(90deg, #55C416 0%, #367910 100%);
            border-color: transparent;
            color: #fff;
        }
        &.add-more-disable {
            background: linear-gradient(90deg, #9c9c9c 0%, #9c9c9c 100%);
            border-color: transparent;
            color: #fff;
        }
    }
    .label-heading{
        margin-bottom:0px;
    }
    .app-input-text {
        margin-bottom: 5px;
        position: relative;
    }
   }

   .rec-close-icon-style{
        width: 10px;
        height: 11px;
        margin-bottom: 12px;
        margin-left: 10px;
        cursor: pointer;
    }
    .rec-button-selected-style{
        cursor: pointer;
        margin-top: 0px;
        height: 36px;
        width: 172px;
        border-radius: 4px;
        background: linear-gradient(180deg,#61b01f 0,#27911b);
        border: none;
        color: #fff;
        font-size: 13px;
    }
    .rec-button-unselected-style{
        cursor: pointer;
        margin-top: 0px;
        height: 36px;
        width: 172px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #111111;
        color: #000;
        font-size: 13px;
    }

    
   .business-name-wrapper {
    display: flex;
    gap: min(5.313vw, 102px);
    align-items: flex-end;
    margin-bottom: 15px;
    > .app-input-text {
        width: 100%;
        margin-bottom: 18px;
        max-width: 896px;
    }
    .custom-select__control{
        border-bottom: 1px solid rgb(224, 224, 224);  
    }
    .equipment-requirements-wrapper {
        max-width: 630px;
        width: 100%;
        .requirements-checkbox {
            display: flex;
    justify-content: space-between;
        }
    }
.uploadPhoto {
    > div {
        max-width: 204px;
        > span {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}
    }
    .clone-outer-wrapper {
        display: flex;
        align-items: center;
        gap: 15px;
    }
    .clone-order-wrapper {
        display: flex;
        align-items: center;
        gap: 10px;
        background: rgba(216, 216, 216, 0.4);
            border: 0.5px solid #D8D8D8;
            border-radius: 4px;
            padding-right: 10px;
        .checkbox-field  {
            
            padding: 5px 9px;
            .checkbox-container {
                margin: 5px 0;
                color: #979797;
                font-size: 14px;
            }
        }
    }
    > div {
        display: flex;
        gap: clamp(20px, 6.25vw, 120px);
        > div {
            flex: 1;
            min-width: 860px;
            :nth-child(2) {
                max-width: 655px;
                min-width: auto;
            }
    }
    }
    .sec-label {
        font-size: 16px;
        line-height: 19px;
        letter-spacing: 0.005em;
        color: #000;
        font-family: "latobold";
        margin-bottom: 15px;
    }
    .label-heading {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        letter-spacing: 0.005em;
        color: #005586;
        margin-bottom: 22px;
    }
    @media (max-width: 1626px) {
        > div {
            > div {
                min-width: 730px;
            }
        }
    }
    @media (max-width: 1478px) {
        > div {
            gap: 40px;
            > div {
                min-width: auto;
            }
        }
    }
    @media (max-width: 1277px) {
        > div {
            > div {
                min-width: 565px;
            }
        }
    }

    .star {
    color: red;
    }
    
`
export const InputFieldsWrapper = styled.div`
    .css-os3nnz-control,.css-1lmoifu-control{
        border-top: none;
        border-right: none;
        border-left: none;
        border-image: initial;
        border-bottom: 1px solid rgb(225, 225, 225);
        border-radius: 0px;
        padding: 0px;
    }
    .css-1r0b6xv-control:hover{
        border-top: none;
        border-right: none;
        border-left: none;
        border-image: initial;
        border-bottom: 1px solid rgb(225, 225, 225);
        border-radius: 0px;
        padding: 0px;
        border: none;
        box-shadow: none;
        border-radius: 0;
        border-color: white !important;
    }
    input{
        border: none;
        border-bottom: 1px solid #e1e1e1;
        border-radius: 0;
        padding: 0;
    }
    .radio-container, .checkbox-container, .sec-label, .label-heading, .custom-file-input1, .app-input-text, .loan-detail-wrapper, .add-more, .MuiInputBase-root input, .css-1dxmcrj-placeholder, .css-b8ldur-Input, .css-1cn00s2-singleValue,.css-1x31k8p-placeholder, .text{
        font-size: 14px !important;
    }
    .hardSoftWoodRadioStyle{
        margin-top: -15px;
        .radio-container{
            padding: 3px 0px 0px 28px;
        }
    }
    button
    {
        max-width: 150px;
    }
    .file-input-wrapper .MuiFormControl-root{
        border:none;
        height: 0;
    }
    .custom-date-piker .MuiIconButton-root .MuiIconButton-label{
        margin-bottom: 5px;
    }
    .MuiInputBase-root{
        input{
            padding-bottom: 8px;
        }       
    }
    .css-4ljt47-MenuList {
        max-height: 180px;
    }

    .loan-detail-wrapper {
        display: grid;
        align-items: flex-end;
        grid-template-columns: 1fr 1fr 1fr 1fr 1fr clamp(80px, 5.417vw, 104px);
        gap: clamp(30px, 2.083vw, 40px);
   }
`;
export const UploadSpec = styled.div`    
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: flex-start;
    /* max-width: 204px; */
    span {
        white-space: normal;
        margin-top: 2px;
        white-space: nowrap;
        overflow: hidden;
        font-size: 14px;
        text-overflow: ellipsis;
        padding-top: 5px;
        cursor: pointer;

    }
    img {
      margin-right: 5px;
      cursor: pointer;

    }
`